import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=8797b3cc&scoped=true&"
import script from "./switch.vue?vue&type=script&lang=js&"
export * from "./switch.vue?vue&type=script&lang=js&"
import style0 from "./switch.vue?vue&type=style&index=0&id=8797b3cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8797b3cc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8797b3cc')) {
      api.createRecord('8797b3cc', component.options)
    } else {
      api.reload('8797b3cc', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=8797b3cc&scoped=true&", function () {
      api.rerender('8797b3cc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/uiKit/switch.vue"
export default component.exports